import React from "react"

import {hasProperty, formatText, formatDate} from '../utils/utils';

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';
import { CheckSquare, XSquare } from 'react-bootstrap-icons';


class ViewEnumeration extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            noLinks: false,
        };


        this.dsd = new dsd();

        this.data = {};
        this.data.Enumeration = null;

        if (this.props.Enumeration){
            this.data.Enumeration = this.props.Enumeration; 
        }

        if (this.props.noLinks){
            this.state.noLinks = this.props.noLinks; 
        }


        this.filters = {};

        this.columns = {
        };

        this.data.id = null;
        if (this.props.id){
            this.data.id = this.props.id; 
        }


    }

    componentDidMount() {

        if (this.data.Enumeration){
            this.setState({"isLoaded":true});
            return;
        }

    };

    view(json){

        if (json){
            return(
                <PD.Table className="panel">
                    <PD.Tbody>                                

                        {hasProperty(json,'name') &&
                            <PD.Tr>                                
                                <PD.Th>Name</PD.Th><PD.Td><PD.PdNavLink to={"/enumeration/" + json._id} > {json.name}</PD.PdNavLink></PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'description') &&
                            <PD.Tr>
                                <PD.Th>Description</PD.Th>
                                <PD.Td>
                                    <PD.MdPresent>
                                        {json.description}
                                    </PD.MdPresent>                                    
                                </PD.Td>
                            </PD.Tr>
                        }


                        {hasProperty(json,'namespace') &&
                            <PD.Tr>                                
                                <PD.Th>Namespace</PD.Th><PD.Td>{json.namespace}</PD.Td>
                            </PD.Tr>
                        }


                        {hasProperty(json,'prefix') &&
                            <PD.Tr>                                
                                <PD.Th>Default Prefix</PD.Th><PD.Td>{json.prefix}</PD.Td>
                            </PD.Tr>
                        }


                        {hasProperty(json,'Structure') &&
                            <PD.Tr>
                                <PD.Th>Structure for additional fields</PD.Th>                                
                                <PD.Td><PD.PdNavLink to={"/structure/" + json.Structure._id} > {json.Structure.name}</PD.PdNavLink></PD.Td>
                            </PD.Tr>
                        }


                        {hasProperty(json,'notes') &&
                            <PD.Tr>
                                <PD.Th>Notes</PD.Th>
                                <PD.Td>
                                    <PD.MdPresent>
                                        {json.notes}
                                    </PD.MdPresent>                                    
                                </PD.Td>
                            </PD.Tr>
                        }

                        {hasProperty(json,'proposals') &&
                            <PD.Tr>
                                <PD.Th>Proposals</PD.Th>
                                <PD.Td>
                                    <PD.MdPresent>
                                        {json.proposals}
                                    </PD.MdPresent>                                    
                                </PD.Td>
                            </PD.Tr>
                        }


                        {hasProperty(json,'status') &&
                            <PD.Tr>                                
                                <PD.Th>Status</PD.Th><PD.Td>{json.status}</PD.Td>
                            </PD.Tr>
                        }

                    </PD.Tbody>
                </PD.Table>
            )
        };
        return null;
    };

    render() {

        if (this.state.isLoaded) {

            return (
                <div>
                    {this.view(this.data.Enumeration)}
                </div>
            )
        }
        else {
            return <div />;
        }

    };    
};
        
export default ViewEnumeration;